import { ArrowRight2, Check, Danger, Information } from 'iconsax-reactjs';
import type { FC, ReactNode } from 'react';
import { cn } from './react';

export type BannerProps = {
  className?: string;
  variant:
    | 'positive'
    | 'notice'
    | 'negative'
    | 'info'
    | 'default'
    | 'transparent';
  children?: ReactNode;
  onClick?: () => void;
  size?: 10 | 11 | 5;
  icon?: boolean;
};

export const Banner: FC<BannerProps> = ({
  className,
  variant,
  children,
  onClick,
  size = 11,
  icon = true,
}) => {
  const Comp = typeof onClick === 'function' ? 'button' : 'div';
  return (
    <Comp
      className={cn(
        'flex items-center font-normal rounded-lg !leading-tight',
        size === 10 && 'p-2 min-h-10 text-xs [&_svg]:size-4 gap-2',
        size === 11 && 'p-3 min-h-11 text-sm [&_svg]:size-5 gap-2',
        size === 5 && 'p-2 min-h-5 text-xs [&_svg]:size-3 gap-1',
        variant === 'notice' && 'bg-background-notice/10 text-content-notice',
        variant === 'positive' &&
          'bg-background-positive/10 text-content-positive',
        variant === 'negative' &&
          'bg-background-negative/10 text-content-negative',
        variant === 'info' && 'bg-background-info/10 text-content-info-bold',
        variant === 'default' &&
          'bg-background-disabled text-content-primary ps-0',
        variant === 'transparent' &&
          'border border-border-disabled bg-transparent text-content-primary',
        typeof onClick === 'function' && 'cursor-pointer hover:brightness-90',
        className,
      )}
      {...(typeof onClick === 'function' && {
        type: 'button',
        onClick,
      })}
    >
      <div className="grow flex items-center justify-start gap-[inherit]">
        {icon &&
          (variant === 'negative' || variant === 'notice' ? (
            <Danger className="shrink-0" size={20} />
          ) : variant === 'info' ? (
            <Information className="shrink-0" size={20} />
          ) : variant === 'positive' ? (
            <Check className="shrink-0" size={20} />
          ) : (
            <div className="w-1 bg-content-primary h-8" />
          ))}
        <div className="text-start">{children}</div>
      </div>
      {typeof onClick === 'function' && (
        <ArrowRight2 size={20} className="shrink-0" />
      )}
    </Comp>
  );
};
